var exports = {
  "nM": "row__ApY3CU",
  "o1": "actions__tIe06l",
  "Tq": "bubble__J_mzvd",
  "qr": "footer__21BYqH",
  "h5": "status__mNAYcN",
  "xy": "sendNowButton__x4zujA",
  "z3": "error__mT6yHI",
};

module.exports = exports;
